<template>
  <div class="guest-meal-apply-container">
    <headTitle title="修改手机号"></headTitle>
    <div class="page-title">修改手机号</div>
    <div class="apply-form">
      <van-form
        ref="form"
        input-align="left"
        error-message-align="left"
        @submit="onSubmit"
      >
        <van-field
          v-model="form.phone"
          label="新手机号"
          placeholder="请输入新手机号"
          type="number"
          maxlength="11"
          :rules="[
            { required: true, message: '请输入新手机号' },
            {
              validator: validatorPhone,
              message: '请输入正确手机号格式'
            }
          ]"
        >
          <template #label>
            <span class="form-label">手机号</span>
          </template>
        </van-field>
        <van-field
          v-model="form.code"
          class="company"
          label="验证码"
          maxlength="6"
          placeholder="请输入短信验证码"
          :rules="[{ required: true, message: '请输入短信验证码' }]"
        >
          <!-- 自定义文本 -->
          <template #label>
            <span class="form-label">验证码</span>
          </template>
          <template #button>
            <van-button
              native-type="button"
              plain
              size="mini"
              class="get-code-btn"
              :disabled="!showTime"
              @click.stop="getCode"
            >
              {{ !showTime ? sendTime + '秒' : '获取验证码' }}
            </van-button>
          </template>
        </van-field>

        <div
          style="
            padding: 43px 16px 150px 16px;
            background-color: #fff !important;
            height: 0 !important;
          "
        >
          <van-button
            square
            block
            type="info"
            native-type="submit"
            style="border-radius: 4px; font-size: 18px"
            color="#FA5050"
          >
            修改
          </van-button>
        </div>
      </van-form>
    </div>
    <van-overlay :show="showLoading">
      <van-loading color="#1989fa" />
    </van-overlay>
  </div>
</template>

<script>
import headTitle from '@/components/headTitle/index.vue';
import { identifyingCode } from '@/api/api';

import { Toast } from 'vant';
import { changePhone } from '@/api/change-phone/index.js';
export default {
  name: 'GuestMealApply',
  components: {
    headTitle
  },
  data() {
    return {
      sendTime: '',
      showTime: true,
      timer: null,
      isShowGenderPicker: false,
      showLoading: false,
      showAdminPicker: false,
      showToastDialog: false,
      companyList: [],
      form: {
        phone: '',
        userId: '',
        code: ''
      },
      isH5: ''
    };
  },

  watch: {},
  async created() {
    this.form.userId = this.$route.query.userId;
    this.isH5 = this.$route.query.isH5;
  },
  mounted() {},
  methods: {
    async getCode() {
      if (!this.form.phone) {
        Toast.fail('请输入手机号!');
        return;
      }
      if (!this.validatorPhone(this.form.phone)) {
        Toast.fail('请输入正确的手机号!');
        return;
      }
      const params = {
        phone: this.form.phone,
        appKey: 'ZHONGHEZHIHUI123!@#'
      };

      const response = await identifyingCode(params);
      if (response.code === 0) {
        Toast('获取验证码成功');
        const defaulTime = 60;
        if (!this.timer) {
          this.sendTime = defaulTime;
          this.showTime = false;
          this.timer = setInterval(() => {
            if (this.sendTime > 0 && this.sendTime <= defaulTime) {
              this.sendTime--;
            } else {
              this.showTime = true;
              clearInterval(this.timer); // 清除定时器
              this.timer = null;
            }
          }, 1000);
        }
      }
    },

    async onSubmit() {
      try {
        this.showLoading = true;
        const res = await changePhone({
          phone: this.form.phone,
          userId: this.form.userId,
          code: this.form.code
        });
        if (res.code === 0) {
          this.$toast.success('修改成功');
          // 清空当前表单
          this.form = {
            phone: '',
            userId: '',
            code: ''
          };
          if (Number(this.isH5) === 1) {
            this.$router.push({
              name: 'ChangePhoneResult'
            });
          } else {
            this.$router.push({
              name: 'Binding'
            });
          }
        } else {
          this.$toast.fail(res.message);
          this.showLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.showLoading = false;
      }
    },

    // 校验手机号
    validatorPhone(value) {
      const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-label {
  font-size: 16px;
  font-family: 'PingFangSC-Regular, sans-serif';
  color: #333333;
  font-weight: 400;
}

::v-deep .van-field__control::-webkit-input-placeholder {
  font-size: 16px;
  font-weight: 400;
  color: rgba(196, 196, 196, 1);
}
::v-deep .van-checkbox-group--horizontal {
  width: 150px;
  text-align: center;
  display: flex;
  align-content: flex-start;
  flex-flow: row wrap;
  justify-content: right;
  .van-checkbox--horizontal {
    flex: 0 0 43%;
    margin-right: 0 !important;
  }
  .van-icon-success {
    border-radius: 2px !important;
  }
}
/* 输入框填写文字样式 */
::v-deep .van-field__control {
  font-size: 16px !important;
  font-family: 'PingFangSC-Regular, sans-serif';
  color: #666666;
  font-weight: 400;
}
.department {
  ::v-deep .van-field__control {
    font-size: 16px !important;
    font-family: 'PingFangSC-Regular, sans-serif';
    color: #666666;
    font-weight: 400;
    flex-wrap: nowrap;
    display: flex;
  }
}

.company {
  ::v-deep .van-field__control::-webkit-input-placeholder {
    font-size: 15px;
    font-weight: 400;
    color: rgba(196, 196, 196, 1);
  }
}
.disabled {
  ::v-deep .van-field__control::-webkit-input-placeholder {
    font-size: 15px;
    font-weight: 400;
    color: #e5e5e5;
  }

  ::v-deep .van-field__right-icon {
    color: #e5e5e5;
  }
}
.content {
  width: 100%;
}
.guest-meal-apply-container {
  height: 100%;
  background-color: #fff;
  .page-title {
    color: #333333;
    font-size: 27px;
    font-weight: 500;
    padding: 94px 0 64px 0;
    text-align: center;
  }
  ::v-deep .van-field__label {
    color: #333333;
    font-size: 16px;
    font-weight: 400;
    width: 68px;
    margin-right: 0;
  }
  .apply-form {
    background: #ffffff;
    .get-code-btn {
      border: 0;
      color: #fa5050;
      font-size: 15px;
      font-weight: 400;
    }

    .manager-toast {
      width: 343px;
      ::v-deep .van-dialog {
        width: 343px;
        border-radius: 10px;
        box-sizing: border-box;
        .van-dialog__header {
          padding-top: 28px;
          margin-bottom: 24px;
        }
        .head {
          font-size: 18px;
          font-family: 'PingFangSC-Regular';
          color: #333333;
          font-weight: 500;
          line-height: 18px;
        }
        .body {
          font-size: 16px;
          font-family: 'PingFangSC-Regular, sans-serif';
          color: #666666;
          font-weight: 400;
          line-height: 1.5;
          margin-bottom: 24px;
          padding: 0 16px;
        }
        .van-dialog__footer {
          height: 50px;
          font-size: 18px;
          font-family: 'PingFangSC-Regular';
          color: #fa5050;
          font-weight: 500;
          line-height: 18px;
        }
      }
    }
  }
}
.form-label-originEndTime {
  font-size: 16px;
  font-family: 'PingFangSC-Regular, sans-serif';
  color: #333333;
  font-weight: 400;
  position: absolute;
  right: 100px;
}

.disabled {
  color: #e5e5e5;
}

::v-deep .van-picker__toolbar {
  height: 50px;
  background-color: #f1f1f1;
  .van-picker__cancel {
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    font-family: 'PingFangSC-Regular, sans-serif';
  }
  .van-picker__confirm {
    font-size: 16px;
    font-weight: 500;
    color: #fa5050;
    font-family: 'PingFangSC-Regular, sans-serif';
  }
}
::v-deep .van-picker-column__item {
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  color: #333333;
  font-family: 'PingFangSC-Regular, sans-serif';
}
.comment-van {
  ::v-deep .van-field__control {
    font-size: 13px !important;
    font-family: 'PingFangSC-Regular, sans-serif';
    color: #333333;
    font-weight: 400;
    background-color: #f2f2f2;
    height: 39px !important;
    line-height: 19.5px;
  }
  ::v-deep .van-field__value {
    height: 82px;
    box-sizing: border-box;
    background-color: #f2f2f2;
    padding: 16px 8px 16px 8px;
    border-radius: 4px;
  }
  ::v-deep .van-field__word-limit {
    color: #999999;
    font-size: 14px;
    background-color: #f2f2f2;
    margin-top: 0;
  }
}
.student-list {
  position: fixed;
  border-radius: 10px;
  overflow-y: auto; /* 添加滚动条 */
  width: 240px;
  max-height: 220px;
  background-color: #fff;
  z-index: 9999; /* 确保学生列表显示在其他内容上方 */
  box-shadow: 0 5px 15px 0 #00000014;
}

.student-list-item {
  width: 100%;
  height: 44px;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  color: #666666;
  font-size: 16px;
  box-sizing: border-box;
  padding: 14px 0 14px 16px;
  font-family: 'PingFangSC-Regular';
  font-weight: 400;
}
</style>
